export default __webpack_public_path__ + "static/media/maker-pro.9f4e96ea.svg";